import * as React from 'react';

import { IconicLink } from '../header-iconic-link';

import { Wrapper, Inner, FeaturesSection } from './header-features-dropdown.styles';

export const FeaturesDropdown = ({ className, links }) => {
  const featuresLinks = links.filter(({ acf: { sectionName } }) => sectionName === 'features');

  return (
    <Wrapper className={className}>
      <Inner>
        <FeaturesSection>
          {featuresLinks.map(({ id, label, description, acf: { featuresLinkName }, url }) => (
            <IconicLink
              title={label}
              description={description}
              to={url}
              linkName={featuresLinkName}
              key={id}
            />
          ))}
        </FeaturesSection>
      </Inner>
    </Wrapper>
  );
};
